import { useState } from "react";
import { motion } from "framer-motion";

function Stat({ label, value, testid }) {
  return (
    <div>
      <motion.p
        key={value}
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.35 }}
        data-testid={testid}
        className="font-display text-4xl md:text-6xl font-black text-hi"
      >
        {value}
      </motion.p>
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-low mt-2">{label}</p>
    </div>
  );
}

export default function Calculator() {
  const [v, setV] = useState(3);
  const fill = ((v - 1) / 24) * 100;

  return (
    <section id="maths" className="py-24 md:py-32 border-t border-line">
      <div className="mx-auto max-w-7xl px-5 md:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-ember">The maths</p>
          <h2 className="font-display text-4xl md:text-5xl font-black uppercase tracking-wide mt-4 leading-[0.95]">
            Slide the fleet.<br />Watch the load vanish.
          </h2>
          <p className="text-mid mt-5 max-w-md">
            Every vehicle carries three deadlines. We watch them all — and email you at 30,
            14, 7 and 1 day out, plus on the due day itself.
          </p>
          <p className="text-sm mt-6 border-l-2 border-ember pl-4 text-hi/80 max-w-md">
            In the UK, driving without a valid MOT can cost up to £1,000 — the tracker makes
            sure that letter never finds you.
          </p>
        </div>

        <div className="lg:col-span-7 rounded-2xl border border-line bg-panel p-6 md:p-10" data-testid="compliance-calculator">
          <div className="flex items-center justify-between font-mono text-[11px] uppercase tracking-[0.2em] text-low">
            <span>Fleet size</span>
            <span data-testid="calculator-fleet-size" className="text-ember text-base font-bold">{v} {v === 1 ? "vehicle" : "vehicles"}</span>
          </div>
          <input
            type="range"
            min="1"
            max="25"
            value={v}
            data-testid="fleet-size-slider"
            onChange={(e) => setV(parseInt(e.target.value, 10))}
            style={{ "--fill": `${fill}%` }}
            className="w-full mt-5"
            aria-label="Fleet size"
          />
          <div className="grid grid-cols-3 gap-4 md:gap-8 mt-10">
            <Stat label="Deadlines watched" value={v * 3} testid="calc-deadlines" />
            <Stat label="Email checkpoints" value={v * 3 * 5} testid="calc-checkpoints" />
            <Stat label="Things you forget" value={0} testid="calc-forgotten" />
          </div>
        </div>
      </div>
    </section>
  );
}
